<div class="landing">
  <nav class="landing__nav">
    <ng-container *ngTemplateOutlet="UHSystemLogo"></ng-container>

    <core-client-block-language></core-client-block-language>
  </nav>

  <div class="landing__body">
    <h1 class="landing__heading">
      {{ 'Explore Financial Wellness' | translate }}
    </h1>
    <p class="landing__subheading">
      {{
        'Welcome to our Financial Wellness Benefits site. Select your campus below to discover a range of resources to help you grow, manage and protect your finances.'
          | translate
      }}
    </p>

    <h2 class="landing__secondary-heading">
      {{ 'Select Your University' | translate }}
    </h2>

    <div class="landing__campus-cards">
      <button class="campus-card" (click)="selectCampus(1)">
        <img class="campus-card__image" src="/assets/img/logo_campus_uoh.jpg" alt="Campus - University of Houston" />

        <div class="campus-card__body">
          <h3 class="campus-card__heading">
            {{ 'University of Houston' | translate }}
          </h3>
          <button class="campus-card__btn" (click)="selectCampus(1)">
            {{ 'Select' | translate }}
            <coro-icon iconType="arrow" position="right"></coro-icon>
          </button>
        </div>
      </button>

      <button class="campus-card" (click)="selectCampus(2)">
        <img
          class="campus-card__image"
          src="/assets/img/logo_campus_clearlake.jpg"
          alt="Campus - University of Houston Clearlake" />

        <div class="campus-card__body">
          <h3 class="campus-card__heading">
            {{ 'University of Houston – Clear Lake' | translate }}
          </h3>
          <button class="campus-card__btn" (click)="selectCampus(2)">
            {{ 'Select' | translate }}
            <coro-icon iconType="arrow" position="right"></coro-icon>
          </button>
        </div>
      </button>

      <button class="campus-card" (click)="selectCampus(3)">
        <img
          class="campus-card__image"
          src="/assets/img/logo_campus_downtown.jpg"
          alt="Campus - University of Houston Downtown" />

        <div class="campus-card__body">
          <h3 class="campus-card__heading">
            {{ 'University of Houston – Downtown' | translate }}
          </h3>
          <button class="campus-card__btn" (click)="selectCampus(3)">
            {{ 'Select' | translate }}
            <coro-icon iconType="arrow" position="right"></coro-icon>
          </button>
        </div>
      </button>
    </div>
  </div>

  <footer class="landing__footer">
    <nav class="landing__footer-nav">
      <ul>
        @for (link of footerLinks; track link) {
          <li>
            <a class="landing__footer-link" [href]="link.url">
              {{ link.text | translate }}
            </a>
          </li>
        }
      </ul>
    </nav>

    <nav class="landing__footer-nav landing__footer-nav-right">
      <ul>
        <li>
          <a href="//policy.cookiereports.com/1b71f3ca-en-gb.html" class="footer-links-list__link internal">{{
            'Cookie Policy' | translate
          }}</a>
        </li>
      </ul>
    </nav>
  </footer>
</div>

<ng-template #UHSystemLogo>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    class="landing__nav-logo"
    version="1.1"
    viewBox="0 0 576.85 27.64"
    aria-hidden="true">
    <defs>
      <style>
        .st0 {
          fill: #fff;
        }
      </style>
    </defs>
    <g>
      <g>
        <path
          class="st0"
          d="M15.33,17.06c0,1.91-.29,3.49-.82,4.45-1.05,1.93-2.77,2.95-4.97,2.95s-3.92-1.02-4.97-2.96c-.53-.96-.82-2.54-.82-4.45V.82H.51v16.24c0,2.15.34,4.04,1,5.45,2.11,4.6,6.68,4.96,8.03,4.96s5.92-.36,8.03-4.96c.65-1.42,1-3.3,1-5.45V.82h-3.24v16.24Z" />
        <polygon
          class="st0"
          points="44.29 21.3 30.51 .82 26.54 .82 26.54 27.01 29.78 27.01 29.78 5.26 44.45 27.01 47.53 27.01 47.53 .82 44.29 .82 44.29 21.3" />
        <rect class="st0" x="55.53" y=".82" width="3.24" height="26.19" />
        <polygon
          class="st0"
          points="76.6 22.58 67.92 1.04 67.83 .82 64.26 .82 75.06 27.01 78.03 27.01 88.9 .82 85.39 .82 76.6 22.58" />
        <polygon
          class="st0"
          points="94.22 27.01 108.87 27.01 108.87 24.02 97.46 24.02 97.46 15.3 108.49 15.3 108.49 12.3 97.46 12.3 97.46 3.82 108.87 3.82 108.87 .82 94.22 .82 94.22 27.01" />
        <path
          class="st0"
          d="M134.14,9.4c0-3.3-1.82-6.21-4.75-7.59-.99-.46-2.61-1-6.42-1h-6.82v26.19h3.24V3.82h4.1c2.01,0,3.3.14,4.81.93,1.51.75,2.6,2.68,2.6,4.59s-1.04,4.25-3.96,5.08c-1.07.32-2.05.36-5.38.36h-.69l9.17,12.24h4.07l-7.25-9.57c4.78-.6,7.28-4.42,7.28-8.04h0Z" />
        <path
          class="st0"
          d="M148.61,11.93l-.2-.06c-3.26-.94-5.62-1.62-5.62-4.4,0-1.99,1.5-4.1,4.27-4.1,2.26,0,4.17,1.96,4.17,4.27v.34h3.24v-.34c0-4.08-3.25-7.27-7.41-7.27s-7.51,3.1-7.51,7.2c0,5.05,4.05,6.23,6.47,6.94l.62.18c1.82.54,5.21,1.54,5.21,5.05,0,2.96-2.44,4.72-4.79,4.72-2.93,0-4.83-1.9-4.96-4.94v-.33h-3.25v.35c.11,5.44,4.33,7.92,8.21,7.92,4.5,0,8.03-3.44,8.03-7.84,0-1.79-.63-6.12-6.49-7.7h0Z" />
        <rect class="st0" x="161.34" y=".82" width="3.24" height="26.19" />
        <polygon
          class="st0"
          points="170.17 3.82 176.03 3.82 176.03 27.01 179.27 27.01 179.27 3.82 185.09 3.82 185.09 .82 170.17 .82 170.17 3.82" />
        <polygon
          class="st0"
          points="198.58 14.72 191.51 .82 187.91 .82 196.99 18.24 196.99 27.01 200.23 27.01 200.23 18.24 209.42 .82 205.84 .82 198.58 14.72" />
        <path
          class="st0"
          d="M221.18,9.3c-4.32,0-8.99,3.51-8.99,9.18,0,4.84,4.12,8.93,8.99,8.93s9.05-4.15,9.05-9.06-4.15-9.05-9.05-9.05ZM221.21,24.81c-3.42,0-6.21-2.85-6.21-6.36,0-4.04,3.22-6.54,6.21-6.54,2.51,0,6.21,2.02,6.21,6.36,0,4.1-3.16,6.54-6.21,6.54Z" />
        <path
          class="st0"
          d="M240.66,6.14h.34v-2.67h-.35c-6.21.07-6.63,4.04-6.7,6.25h-2.59v2.6h2.58v14.69h2.81v-14.69h4.25v-2.6h-4.25c0-.69.06-1.55.48-2.23.57-.92,1.69-1.36,3.43-1.36h0Z" />
      </g>
      <polygon
        class="st0"
        points="251.45 .58 258.15 .58 258.15 10.43 266.72 10.43 266.72 .58 273.42 .58 273.42 26.79 266.72 26.79 266.72 16.31 258.15 16.31 258.15 26.79 251.45 26.79 251.45 .58" />
      <path
        class="st0"
        d="M292.62.08c8.08,0,13.85,6.31,13.85,13.61s-5.74,13.61-13.89,13.61-13.78-6.56-13.78-13.29c0-1.74.25-3.68,1.03-5.6,1.38-3.4,5.46-8.33,12.79-8.33M292.73,21.41c4.75,0,7.05-4.32,7.05-7.69s-2.3-7.76-7.12-7.76-7.15,3.97-7.15,7.65c0,4.04,2.73,7.79,7.23,7.79" />
      <path
        class="st0"
        d="M318.49.58v15.84c0,1.77.11,4.99,3.4,4.99s3.33-2.9,3.33-4.99V.58h6.69v15.84c0,4.39-.95,6.34-2.62,8.04-1.7,1.74-4.07,2.84-7.33,2.84-1.91,0-5.38-.46-7.54-2.8-2.16-2.37-2.62-4.22-2.62-8.07V.58h6.69Z" />
      <path
        class="st0"
        d="M348.64,8.23c-.14-.89-.35-2.55-2.41-2.55-1.17,0-2.3.81-2.3,2.06,0,1.56.71,1.88,5.42,4,4.89,2.2,6.13,4.47,6.13,7.51,0,3.82-2.2,8.04-9.14,8.04-7.58,0-9.46-4.96-9.46-8.33v-.85h6.66c0,3.05,1.88,3.58,2.73,3.58,1.6,0,2.55-1.31,2.55-2.52,0-1.74-1.1-2.16-5.14-3.86-1.84-.74-6.41-2.59-6.41-7.51S342.05.08,346.45.08c2.59,0,5.38.96,7.09,2.98,1.56,1.91,1.66,3.68,1.74,5.17h-6.64Z" />
      <polygon
        class="st0"
        points="363.59 6.46 358.42 6.46 358.42 .58 375.42 .58 375.42 6.46 370.29 6.46 370.29 26.79 363.59 26.79 363.59 6.46" />
      <path
        class="st0"
        d="M392.04.08c8.08,0,13.85,6.31,13.85,13.61s-5.74,13.61-13.89,13.61-13.78-6.56-13.78-13.29c0-1.74.25-3.68,1.03-5.6,1.38-3.4,5.46-8.33,12.79-8.33M392.15,21.41c4.75,0,7.05-4.32,7.05-7.69s-2.3-7.76-7.12-7.76-7.16,3.97-7.16,7.65c0,4.04,2.73,7.79,7.23,7.79" />
      <polygon
        class="st0"
        points="411.28 .58 417.05 .58 427.19 17.05 427.26 16.98 426.97 .58 433.39 .58 433.39 26.79 427.58 26.79 417.59 10.85 417.52 10.89 417.69 26.79 411.28 26.79 411.28 .58" />
    </g>
    <g>
      <polygon
        class="st0"
        points="527.79 27.03 542.44 27.03 542.44 24.03 531.03 24.03 531.03 15.31 542.06 15.31 542.06 12.31 531.03 12.31 531.03 3.84 542.44 3.84 542.44 .84 527.79 .84 527.79 27.03" />
      <path
        class="st0"
        d="M454.16,11.95l-.2-.06c-3.26-.94-5.62-1.62-5.62-4.4,0-1.99,1.5-4.1,4.27-4.1,2.26,0,4.17,1.96,4.17,4.27v.34h3.24v-.34c0-4.08-3.26-7.27-7.41-7.27s-7.51,3.1-7.51,7.2c0,5.05,4.05,6.23,6.47,6.94l.62.18c1.82.54,5.21,1.54,5.21,5.05,0,2.96-2.44,4.72-4.79,4.72-2.93,0-4.83-1.9-4.96-4.94v-.33h-3.25v.35c.11,5.44,4.33,7.92,8.21,7.92,4.51,0,8.03-3.44,8.03-7.84,0-1.79-.63-6.12-6.49-7.7h.01Z" />
      <path
        class="st0"
        d="M496.75,11.95l-.2-.06c-3.26-.94-5.62-1.62-5.62-4.4,0-1.99,1.5-4.1,4.27-4.1,2.26,0,4.17,1.96,4.17,4.27v.34h3.24v-.34c0-4.08-3.26-7.27-7.41-7.27s-7.51,3.1-7.51,7.2c0,5.05,4.05,6.23,6.47,6.94l.62.18c1.82.54,5.21,1.54,5.21,5.05,0,2.96-2.44,4.72-4.79,4.72-2.93,0-4.83-1.9-4.96-4.94v-.33h-3.25v.35c.11,5.44,4.33,7.92,8.21,7.92,4.5,0,8.03-3.44,8.03-7.84,0-1.79-.63-6.12-6.49-7.7h.01Z" />
      <polygon
        class="st0"
        points="507.27 3.83 513.12 3.83 513.12 27.03 516.37 27.03 516.37 3.83 522.19 3.83 522.19 .84 507.27 .84 507.27 3.83" />
      <polygon
        class="st0"
        points="473.79 14.73 466.73 .84 463.12 .84 472.2 18.26 472.2 27.03 475.44 27.03 475.44 18.26 484.63 .84 481.06 .84 473.79 14.73" />
      <polygon
        class="st0"
        points="572.13 .9 563.13 22.54 554.09 .9 549.71 .9 549.71 26.96 552.84 26.96 552.84 5.69 561.73 26.96 564.49 26.96 573.39 5.69 573.39 26.96 576.51 26.96 576.51 .9 572.13 .9" />
    </g>
  </svg>
</ng-template>
